import { BATCH_PREFLIGHT_LABELS } from "./messages";

export interface BatchResultSkip {
  id: number | null;
  reason: string;
}

export type SkipReasonLabels = Readonly<Record<string, string>>;

export const summarizeSkipped = (
  skipped: BatchResultSkip[],
  labels: SkipReasonLabels = BATCH_PREFLIGHT_LABELS.SKIP_REASON,
): string => {
  const counts = new Map<string, number>();

  (skipped ?? []).forEach((item: BatchResultSkip): void => {
    counts.set(item.reason, (counts.get(item.reason) ?? 0) + 1);
  });

  return [...counts.entries()]
    .map(
      ([reason, count]: [string, number]): string =>
        `${count} ${labels[reason] ?? BATCH_PREFLIGHT_LABELS.UNKNOWN_SKIP_REASON}`,
    )
    .join(" · ");
};
